import { APP_ROUTES } from 'constants/routes';
import { decodeURIComponentSafe } from 'helpers/BrowserHelpers';

import { getCommonListingPageSeoProps, getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type { IPromotionPageUrlParams, PageSeoProps, TFunction } from 'types';

export function getPromotionsPageSeoProps(t: TFunction): PageSeoProps {
  return {
    seoProps: {
      title: t('NAVIGATION.PROMOTIONS'),
      description: t('SEO.PROMOTIONS.DESCRIPTION'),
      noindex: false,
      openGraph: {
        description: t('SEO.PROMOTIONS.DESCRIPTION'),
        url: getOpenGraphUrl()
      }
    },
    breadcrumbs: getPageSeoBreadcrumbs(t)
  };
}

export function getPromotionPageSeoProps(
  t: TFunction,
  urlParams: IPromotionPageUrlParams,
  name?: string,
): PageSeoProps {
  const decodedName = decodeURIComponentSafe(name);
  return {
    seoProps: {
      ...getCommonListingPageSeoProps(urlParams),
      title: `${decodedName} - ${t('NAVIGATION.PROMOTIONS')}`,
      description: `${decodedName} - ${t('SEO.PROMOTION.DESCRIPTION')}`,
      openGraph: {
        description: `${decodedName} - ${t('SEO.PROMOTION.DESCRIPTION')}`,
        url: getOpenGraphUrl()
      },
    },
    breadcrumbs: getPageSeoBreadcrumbs(t, [
      { name: t('NAVIGATION.PROMOTIONS'), slug: APP_ROUTES.PROMOTIONS }
    ])
  };
}
